/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../../../common/languages';
import '../../../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "CreatePlaidLinkTokenRequest": {
                    "fields": {
                      "customerId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "language": {
                        "type": ".squareup.common.languages.Language",
                        "id": 2,
                        "rule": "optional"
                      },
                      "isVerifyingManualDeposits": {
                        "type": "bool",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "CreatePlaidLinkTokenResponse": {
                    "fields": {
                      "plaidRequestId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "plaidLinkToken": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "expiresAt": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": ".squareup.connect.v2.resources.Error",
                        "id": 4,
                        "rule": "repeated"
                      },
                      "gringottsSessionToken": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.CreatePlaidLinkTokenRequest && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.CreatePlaidLinkTokenResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CreatePlaidLinkTokenRequest @ squareup/sfs/external/services/external_bank_account/create_plaid_link_token.proto at 9:1
 */
export const CreatePlaidLinkTokenRequest = $root.lookupType('squareup.sfs.external.service.CreatePlaidLinkTokenRequest');
fixType(CreatePlaidLinkTokenRequest, {
  customerId: {
    required: true
  }
});
Builder.createAndAttachToType(CreatePlaidLinkTokenRequest);
/**
 * SOURCE CreatePlaidLinkTokenResponse @ squareup/sfs/external/services/external_bank_account/create_plaid_link_token.proto at 26:1
 */
export const CreatePlaidLinkTokenResponse = $root.lookupType('squareup.sfs.external.service.CreatePlaidLinkTokenResponse');
fixType(CreatePlaidLinkTokenResponse, {
  plaidLinkToken: {
    required: true
  },
  expiresAt: {
    required: true
  }
});
Builder.createAndAttachToType(CreatePlaidLinkTokenResponse);